var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStronglyAgreeColour(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StronglyAgree_Colour") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Evaluation_OpinionScale-(Slider-active---Strongly-Agree)",
    transform: "translate(-217.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Selectors/OpinionScale",
    transform: "translate(16.000000, 242.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Agree",
    transform: "translate(201.039305, 109.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#148967",
    cx: 20.9606952,
    cy: 20.9606952,
    r: 20.9606952
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(8.495455, 17.743316)",
    fill: "#495059",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.881550802,3.67062032 C0.416406417,3.67062032 0.0393048128,3.29351872 0.0393048128,2.82837433 L0.0393048128,0.873240642 C0.0393048128,0.408096257 0.416406417,0.0309946524 0.881550802,0.0309946524 C1.34669519,0.0309946524 1.72379679,0.408096257 1.72379679,0.873240642 L1.72379679,2.82837433 C1.72379679,3.29363102 1.34669519,3.67062032 0.881550802,3.67062032 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4652406,7.62468449 L12.4652406,7.62468449 C10.6426203,7.62468449 9.16498396,6.14716043 9.16498396,4.32442781 L9.16498396,1.92503743 C9.16498396,1.4274385 9.56836364,1.02417112 10.0658503,1.02417112 L14.8645187,1.02417112 C15.3621176,1.02417112 15.765385,1.4275508 15.765385,1.92503743 L15.765385,4.32442781 C15.7654973,6.14716043 14.287861,7.62468449 12.4652406,7.62468449 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0489305,3.67062032 C23.5837861,3.67062032 23.2066845,3.29351872 23.2066845,2.82837433 L23.2066845,0.873240642 C23.2066845,0.408096257 23.5837861,0.0309946524 24.0489305,0.0309946524 C24.5140749,0.0309946524 24.8911765,0.408096257 24.8911765,0.873240642 L24.8911765,2.82837433 C24.8911765,3.29363102 24.5141872,3.67062032 24.0489305,3.67062032 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.642615,35.9177487 C0.861898396,41.9207166 0.382042781,11.9166578 12.9644118,1.58072727 C5.3554492,4.72387701 0.000336898397,12.2161604 0.000336898397,20.9603583 C0.000336898397,32.5364118 9.38464171,41.9207166 20.9606952,41.9207166 C26.6787594,41.9207166 31.8609305,39.6301444 35.642615,35.9177487 Z",
    id: "Path",
    fill: "#ABABAB",
    opacity: 0.2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStronglyAgreeColour);
export default __webpack_public_path__ + "static/media/StronglyAgree_Colour.ec0f727c3a5a64672925629048eebd49.svg";
export { ForwardRef as ReactComponent };